import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? window.localStorage.getItem("ceo_lang") : null;
    return saved && translations[saved] ? saved : "id";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("ceo_lang", lang);
      document.documentElement.lang = lang;
    } catch (err) {
      console.warn("localStorage unavailable for ceo_lang", err);
    }
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
